module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.app_visible),
      expression: "app_visible"
    }],
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "core",
    attrs: {
      "id": "CORE-SWF",
      "onselectstart": "return false"
    }
  }, [_c('keep-alive', [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "timeline_toolbar"
  }, [_vm._l((_vm.toolbar_list), function(item, index) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.toolbarOpe(item)
        }
      }
    }, [_c('i', {
      class: 'icon-' + item[0]
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "jiantou"
  })], 2), _vm._v(" "), (_vm.export_status) ? _c('div', {
    staticClass: "export"
  }, [_c('export')], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "分享",
      "visible": _vm.share_show_start,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.share_show_start = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "body"
  }, [_c('el-form-item', {
    attrs: {
      "label": "分享周期"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.share_select_time),
      callback: function($$v) {
        _vm.share_select_time = $$v
      },
      expression: "share_select_time"
    }
  }, _vm._l((_vm.share_select_times), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_vm._v("\n            " + _vm._s("有效期至     " + this.share_select_deadline) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": this.share_select_time == ''
    },
    on: {
      "click": function($event) {
        return _vm.handleStartShare()
      }
    }
  }, [_vm._v(_vm._s("启用"))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "分享",
      "visible": _vm.share_show_stop,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.share_show_stop = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "body"
  }, [_c('el-form-item', [_vm._v("\n          " + _vm._s("有效期至  " + this.timestamp(this.share_deadline * 1000))), _c('font', {
    attrs: {
      "color": "#ff0000"
    }
  }, [_vm._v("   (已启用)")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "播放链接"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 4
    }
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-input', {
    staticStyle: {},
    attrs: {
      "disabled": true,
      "resize": "none",
      "placeholder": this.share_url
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-button', {
    attrs: {
      "id": "copy_btn",
      "size": "mini",
      "data-clipboard-action": "copy",
      "data-clipboard-target": "#clipboard"
    },
    on: {
      "click": function($event) {
        return _vm.handleShareCopy()
      }
    }
  }, [_vm._v("复制")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleStopShare()
      }
    }
  }, [_vm._v(_vm._s("停用"))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": _vm.text_box_data.title,
      "visible": _vm.text_box_show,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.text_box_show = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "body"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.text_box_data.text
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.text_box_data.value
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleTextBox()
      }
    },
    model: {
      value: (_vm.text_box_data.value),
      callback: function($$v) {
        _vm.$set(_vm.text_box_data, "value", $$v)
      },
      expression: "text_box_data.value"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "width": "0px",
      "height": "0px",
      "border": "0px solid white"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleTextBox()
      }
    }
  }, [_vm._v(_vm._s(_vm.text_box_data.button))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": _vm.alertData.title,
      "visible": _vm.dialog_create_action_visible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_create_action_visible = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "body"
  }, [_c('el-form-item', [_vm._v("\n          " + _vm._s(_vm.alertData.text) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.handleAlertButton(_vm.alertData.id, (_vm.alertData.buttonsList ? _vm.alertData.buttonsList[0].id : ''))
      }
    }
  }, [_vm._v(_vm._s(_vm.alertData.buttonsList ? _vm.alertData.buttonsList[0].text : ''))]), _vm._v(" "), (_vm.alertData.buttonsList && _vm.alertData.buttonsList.length > 1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleAlertButton(_vm.alertData.id, (_vm.alertData.buttonsList ? _vm.alertData.buttonsList[1].id : ''))
      }
    }
  }, [_vm._v(_vm._s(_vm.alertData.buttonsList ? _vm.alertData.buttonsList[1].text : ''))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog dialog-delete",
    attrs: {
      "title": "提示",
      "visible": _vm.dialog_lock_anim,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_lock_anim = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dialog_lock_anim_msg))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.closeAnim()
      }
    }
  }, [_vm._v("退出编辑")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pop_block_show),
      expression: "pop_block_show"
    }],
    staticClass: "pop_block",
    style: ({
      left: (_vm.pop_block_left + _vm.pop_block_originX) + 'px',
      top: (_vm.pop_block_originY + 36) + 'px'
    }),
    attrs: {
      "id": "pop_block"
    }
  }, [_c('div', {
    directives: [{
      name: "drag",
      rawName: "v-drag"
    }],
    staticClass: "top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("序列帧设置")]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.pop_block_show = false
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "rate"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("帧速率: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rate_input_model),
      expression: "rate_input_model"
    }],
    staticClass: "rate_select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rate_input_model = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handleRateSelectChange]
    }
  }, _vm._l((_vm.rate_input_list), function(item) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v("  帧/秒\n              "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "position": "absolute",
      "margin-left": "-5px",
      "margin-top": "-2px",
      "width": "130px",
      "height": "25px",
      "line-height": "25px",
      "font-size": "10px",
      "-webkit-transform": "scale(0.8)",
      "color": "#959595"
    }
  }, [_vm._v("每秒钟播放图片帧数")])]), _vm._v(" "), _c('div', {
    staticClass: "loop"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("循环:")]), _vm._v(" "), _c('el-radio-group', {
    on: {
      "change": _vm.handleChangeOption
    },
    model: {
      value: (_vm.loop_data),
      callback: function($$v) {
        _vm.loop_data = $$v
      },
      expression: "loop_data"
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("否")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "duration"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("移动时长: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.duration_input_model),
      expression: "duration_input_model"
    }],
    staticClass: "duration_input",
    class: {
      'disabled': _vm.duration_input_disabled
    },
    attrs: {
      "type": "text",
      "disabled": _vm.duration_input_disabled
    },
    domProps: {
      "value": (_vm.duration_input_model)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.duration_input_model = $event.target.value
      }, function($event) {
        return _vm.handleInputEditing('duration')
      }]
    }
  }), _vm._v("   秒\n              "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "position": "absolute",
      "margin-left": "-5px",
      "margin-top": "-2px",
      "width": "130px",
      "height": "25px",
      "line-height": "25px",
      "font-size": "10px",
      "-webkit-transform": "scale(0.8)",
      "color": "#959595"
    }
  }, [_vm._v("0表示不可移动")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clipboard",
    staticStyle: {
      "text-indent": "-9999px"
    },
    attrs: {
      "id": "clipboard"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f7becaa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 399
// module chunks = 0